import type { FC } from 'react';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { paths } from '../../../../routing/Router/paths';
import { canCreateCategory } from '../../../../utils/auth';
import { navigateTo } from '../../utils';
import { Edit as EditPage } from '../Edit';

export const Create: FC = () => {
  const routeParams = useParams();
  const hasCategoryCreationRights = canCreateCategory();

  useEffect(() => {
    if (!hasCategoryCreationRights) {
      navigateTo({
        pathname: paths.PAGE_LIST,
        routeParams,
      });
    }
  }, [hasCategoryCreationRights, routeParams]);

  if (!hasCategoryCreationRights) {
    return null;
  }

  return (
    <div>
      <EditPage />
    </div>
  );
};
